export const statusRefChangeLanguage = 'App-changeLanguage';
export const statusRef = 'App-init';
export const statusRefPrescriptorCode = 'PromotingBanner-PrescriptorCode';
export const statusRefSeoPages = 'App-getSeoPages';
